import type {
  SilaeLocationsSchema,
  UpdateSilaeLocationsPayload
} from '@libs/data-access/entities'
import { type QueryFnParams, httpServices } from '@libs/data-access/queries'

export type FetchSilaeLocationsOptions = QueryFnParams<{}>

export const fetchSilaeLocations = async (
  opts?: FetchSilaeLocationsOptions
) => {
  const response = await httpServices.core.get<SilaeLocationsSchema[]>(
    '/silae/locations',
    opts
  )
  return response.data
}

export type PutSilaeLocationsOptions = QueryFnParams<{
  payload: UpdateSilaeLocationsPayload
}>

export const putSilaeLocations = async (opts?: PutSilaeLocationsOptions) => {
  const response = await httpServices.core.put<SilaeLocationsSchema[]>(
    '/silae/locations/bulk_update',
    opts?.payload
  )
  return response.data
}
